import React from 'react'
import { IonPage, IonToolbar, IonHeader, IonTitle, IonContent, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCardSubtitle, IonButton, IonIcon } from '@ionic/react'
import { Link } from 'react-router-dom'
import { informationCircleOutline, trophyOutline, imagesOutline, personAddOutline, settingsOutline } from 'ionicons/icons'

const NotFound = () => {
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>
                        Not Found 404
                    </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonCard>
                    <IonCardHeader style={{textAlign:'center'}}>
                        <IonCardTitle>The Page You Have Requested Is Not Found !!!</IonCardTitle>
                        <IonCardSubtitle>Please Click On The Buttons Below To Go To Your Desired Page </IonCardSubtitle>
                    </IonCardHeader>
                    <IonCardContent>
                        <Link to="/about" style={{textDecoration:'none'}}>
                            <IonButton mode="ios" expand="full" shape="round">
                                <IonIcon icon={informationCircleOutline} mode="ios" /> &nbsp;&nbsp;
                                About
                            </IonButton>
                        </Link>
                        <Link to="/achievements" style={{ textDecoration: 'none' }}>
                            <IonButton mode="ios" expand="full" shape="round">
                                <IonIcon icon={trophyOutline} mode="ios" /> &nbsp;&nbsp;
                                Achievements
                            </IonButton>
                        </Link>
                        <Link to="/pics" style={{ textDecoration: 'none' }}>
                            <IonButton mode="ios" expand="full" shape="round">
                                <IonIcon icon={imagesOutline} mode="ios" /> &nbsp;&nbsp;
                                Gallery
                            </IonButton>
                        </Link>
                        <Link to="/joinus" style={{ textDecoration: 'none' }}>
                            <IonButton mode="ios" expand="full" shape="round">
                                <IonIcon icon={personAddOutline} mode="ios" /> &nbsp;&nbsp;
                                Join Us
                            </IonButton>
                        </Link>
                        <Link to="/settings" style={{ textDecoration: 'none' }}>
                            <IonButton mode="ios" expand="full" shape="round">
                                <IonIcon icon={settingsOutline} mode="ios" /> &nbsp;&nbsp;
                                Settings
                            </IonButton>
                        </Link>
                    </IonCardContent>
                </IonCard>
            </IonContent>
        </IonPage>
    )
}

export default NotFound
